import React from 'react';

export const GeographicExposureTab = () => {
  return (
    <div data-testid="geographic-exposure-tab">
      <div>Geographic Exposure Tab - Coming Soon</div>
    </div>
  );
};
